// CustomSelect.js
import {FC, useEffect, useState} from 'react'
import {useInfiniteQuery} from 'react-query'
import Select from 'react-select'
import clsx from 'clsx'
import {stringifyRequestQuery, useDebounce} from '../../../../_metronic/helpers'
import {SelectWithMoreWrapper} from '../../../components/LoadMore'
import {getSatwil} from '../core/_request'

interface Props {
  field?: any
  form?: any
  value?: any
  isFormik?: boolean
  className?: string
  defaultOption?: any
  initialOptions?: any[]
  isClearable?: boolean
  isMulti?: boolean
  disabled?: boolean
  onChange?: (data) => void
  placeholder?: string
  levelId?: any
  refetchOnFocus?: boolean
}

const SatwilSelect: FC<Props> = ({
  field,
  form,
  value,
  isFormik = false,
  isClearable = false,
  className = '',
  defaultOption,
  initialOptions = [],
  isMulti,
  disabled = false,
  onChange,
  placeholder,
  levelId,
  refetchOnFocus = false,
  ...rest
}) => {
  const setFieldValue = form?.setFieldValue || undefined
  const [keyword, setKeyword] = useState<string | undefined>(undefined)
  const debouncedSearchTerm = useDebounce(keyword, 150)
  const [selectedValues, setSelectedValues] = useState<any[]>(initialOptions ?? [])
  const [options, setOptions] = useState<any[]>([...initialOptions])
  const [initial, setInitial] = useState(false)
  const [selectedOption, setSelectedOption] = useState<any | null>(null)

  const fetchData = async ({pageParam = 1}) => {
    try {
      const response = await getSatwil(
        stringifyRequestQuery({
          keyword: debouncedSearchTerm,
          pageSize: 10,
          pageNumber: pageParam,
          filter: {
            levelId,
          },
        })
      )

      return response.data
    } catch (ex) {
      console.log(ex)
      return undefined
    }
  }

  const {isLoading, data, refetch, fetchNextPage, hasNextPage, isFetching} = useInfiniteQuery(
    'satwil-select',
    fetchData,
    {
      enabled: false,
      getNextPageParam: (lastPage) => {
        if (!lastPage?.totalPages) return undefined

        const hasNext = lastPage.totalPages > (lastPage.pageNumber || 0)
        if (hasNext) {
          return (lastPage.pageNumber || 0) + 1
        } else {
          return undefined
        }
      },
      getPreviousPageParam: (lastPage) => {
        if (!lastPage) return undefined

        const prev = (lastPage.pageNumber || 0) - 1
        return prev < 1 ? undefined : prev
      },
      cacheTime: 0,
    }
  )

  const handleChange = (selectedOptionArg) => {
    if (isMulti) {
      const data = selectedOptionArg.map((q) => {
        return {
          evidenceId: q.value,
          evidenceName: q.label,
        }
      })
      if (isFormik) {
        setFieldValue(field.name, data)
      }
    } else {
      if (isFormik) {
        setFieldValue(field.name, selectedOptionArg.value??null)
      }
      setSelectedOption(selectedOptionArg ?? null) // ← simpan object agar tidak hilang
    }

    if (onChange) {
      onChange(selectedOptionArg)
    }
  }

  useEffect(() => {
    let list = data?.pages?.flatMap((q) => q?.records) || []
    list = list.filter((q) => q !== undefined)
    const result = list.map((q) => {
      return {
        value: q?.id,
        label: q?.name,
      }
    })

    setOptions(result)
  }, [data])

  const handleInputChange = (value) => {
    setKeyword(value)
  }

  useEffect(() => {
    if (debouncedSearchTerm === undefined) return
    refetch()
  }, [debouncedSearchTerm])

  useEffect(() => {
    if (levelId === undefined) return
    if (!initial) return
    refetch()
  }, [levelId])

  const handleScrollToBottom = () => {
    if (hasNextPage) {
      fetchNextPage()
    }
  }

  const handleLabel = (option: any) => {
    return `${option.label}`
  }

  // const SubjectOptions = props => {
  //   const { innerProps, innerRef } = props;
  //
  //   return (
  //     <article ref={innerRef} {...innerProps} className="custom-option">
  //       <h4>{props.data.label}</h4>
  //       <div className="sub">{props.data.code} </div>
  //     </article>
  //   );
  // }

  const formatLabel = (option: any) => {
    return (
      <article className='custom-option text-wrap' style={{lineHeight: 1.1}}>
        <div>
          {/* {option.degree} - {option.label} <small className='sub'>({option.code})</small> */}
          {option.label}
        </div>
      </article>
    )
  }

  // useEffect(() => {
  //   if (isMulti && isFormik && field.value) {
  //     const result = field.value.map((q) => {
  //       return {
  //         value: q?.id,
  //         label: q?.name,
  //       }
  //     })

  //     setSelectedValues(result)
  //   }

  //   if (isMulti && !isFormik && value) {
  //     const result = value.map((q) => {
  //       return {
  //         value: q?.id,
  //         label: q?.name,
  //       }
  //     })

  //     setSelectedValues(result)
  //   }
  // }, [field, isFormik, value])

  useEffect(() => {
  if (isMulti) return
  const currentId = isFormik ? field?.value : value
  if (currentId == null) {
    setSelectedOption(null)
    return
  }
  // cari di options dulu
  const inOptions = (options.length === 0 ? initialOptions : options)
    .find(opt => opt.value === currentId)
  if (inOptions) {
    setSelectedOption(inOptions)
  } else if (selectedOption?.value !== currentId) {
    // jika belum ada di options, tetap pertahankan yang lama (biar tidak hilang)
    // atau buat placeholder minimal:
    setSelectedOption(selectedOption ?? { value: currentId, label: String(currentId) })
  }
}, [isFormik, field?.value, value, options, initialOptions])

  const handleOnFocus = () => {
    if (refetchOnFocus) {
      refetch()
    }
  }

  return (
    <SelectWithMoreWrapper hasMore={hasNextPage || false} isLoading={isFetching}>
      <Select
        {...rest}
        name={isFormik ? field.name : 'SatwilSelect'}
        isLoading={isLoading}
        options={options.length === 0 ? initialOptions : options}
        onChange={handleChange}
        // value={
        //   isMulti
        //     ? selectedValues
        //     : (options.length === 0 ? initialOptions : options).find(
        //         (opt) => opt.value === (isFormik ? field.value : value)
        //       ) ??
        //       initialOptions.find((opt) => opt.value === (isFormik ? field.value : value)) ??
        //       null
        // }
        value={ isMulti ? selectedValues : selectedOption }
        classNamePrefix='react-select'
        isMulti={isMulti}
        className={clsx(
          'react-select',
          className,
          {'is-invalid': isFormik && form.touched[field.name] && form.errors[field.name]},
          {'is-valid': isFormik && form.touched[field.name] && !form.errors[field.name]}
        )}
        isClearable={isClearable}
        onInputChange={handleInputChange}
        onMenuOpen={() => {
          if (!initial) setInitial(true)
          handleInputChange('')
        }}
        styles={{
          menuPortal: (base) => ({...base, zIndex: 9999}),
          placeholder: (base) => ({...base, color: '#99A1B7'}),
        }}
        menuPortalTarget={document.body}
        menuShouldScrollIntoView={false}
        onMenuScrollToBottom={handleScrollToBottom}
        getOptionLabel={(option) => handleLabel(option)}
        formatOptionLabel={(data) => formatLabel(data)}
        placeholder={placeholder || 'Type to search...'}
        isDisabled={disabled}
        onFocus={handleOnFocus}
      />
    </SelectWithMoreWrapper>
  )
}

export default SatwilSelect
